import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTableSpecialFilter } from "../../../hooks/table/useTableSpecialFilter";
import { useGeometrySelectionConditions } from "../../../hooks/geometrySelection/useGeometrySelectionConditions";
import { getDateFilterConditions } from "../../../ducks/dateFilter/selectors";

import { FilterConditionOperation } from "../../LayerFilter/types";

export const useSpecialTableFilterCondition = () => {
  const [{ layerName, attribute, tableFilterCondition, filterType }] = useTableSpecialFilter();
  const geometrySelectionConditions = useGeometrySelectionConditions();
  const dateFilterConditions = useSelector(getDateFilterConditions);

  return useMemo(
    () =>
      [
        tableFilterCondition
          ?.split(` ${FilterConditionOperation.AND} `)
          .map(item => {
            const regex = filterType?.range
              ? new RegExp(`(!*between\\(${attribute},\\s[\\d.]+,\\s[\\d.]+\\))`, "gi")
              : new RegExp(`(\\(${attribute}\\s==\\s".*"\\))`, "gi");

            return item.trim().replace(regex, "");
          })
          .filter(Boolean)
          .join(` ${FilterConditionOperation.AND} `),
        geometrySelectionConditions?.[layerName],
        dateFilterConditions?.[layerName],
      ]
        .filter(Boolean)
        .join(` ${FilterConditionOperation.AND} `),
    [layerName, tableFilterCondition, geometrySelectionConditions, dateFilterConditions, attribute],
  );
};
